var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserGroupDuotoneSolid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 26,
    viewBox: "0 0 33 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-group-duotone-solid 1",
    clipPath: "url(#clip0_492_7557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.9683 11.3936C18.9833 12.3848 20.3833 13 21.9333 13C25.0283 13 27.5333 10.5537 27.5333 7.53125C27.5333 4.50879 25.0283 2.0625 21.9333 2.0625C20.6933 2.0625 19.5483 2.45801 18.6183 3.12207C19.2033 4.20605 19.5333 5.44141 19.5333 6.75C19.5333 8.48828 18.9533 10.0947 17.9683 11.3936ZM20.8433 16.1348C22.9783 17.9219 24.3333 20.583 24.3333 23.5469V23.9375C24.3333 24.5088 24.1783 25.041 23.9033 25.5H30.7933C31.6433 25.5 32.3283 24.8262 32.3283 24.001C32.3333 19.6504 28.7233 16.125 24.2683 16.125H21.1983C21.0783 16.125 20.9583 16.1299 20.8433 16.1348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5333 13C13.2306 13 14.8585 12.3415 16.0587 11.1694C17.259 9.99732 17.9333 8.4076 17.9333 6.75C17.9333 5.0924 17.259 3.50269 16.0587 2.33058C14.8585 1.15848 13.2306 0.5 11.5333 0.5C9.83587 0.5 8.208 1.15848 7.00777 2.33058C5.80754 3.50269 5.13325 5.0924 5.13325 6.75C5.13325 8.4076 5.80754 9.99732 7.00777 11.1694C8.208 12.3415 9.83587 13 11.5333 13ZM9.24825 15.3438C4.32325 15.3438 0.333252 19.2402 0.333252 24.0498C0.333252 24.8506 0.998252 25.5 1.81825 25.5H21.2483C22.0683 25.5 22.7333 24.8506 22.7333 24.0498C22.7333 19.2402 18.7433 15.3438 13.8183 15.3438H9.24825Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5333 13C13.2306 13 14.8585 12.3415 16.0587 11.1694C17.259 9.99732 17.9333 8.4076 17.9333 6.75C17.9333 5.0924 17.259 3.50269 16.0587 2.33058C14.8585 1.15848 13.2306 0.5 11.5333 0.5C9.83587 0.5 8.208 1.15848 7.00777 2.33058C5.80754 3.50269 5.13325 5.0924 5.13325 6.75C5.13325 8.4076 5.80754 9.99732 7.00777 11.1694C8.208 12.3415 9.83587 13 11.5333 13ZM9.24825 15.3438C4.32325 15.3438 0.333252 19.2402 0.333252 24.0498C0.333252 24.8506 0.998252 25.5 1.81825 25.5H21.2483C22.0683 25.5 22.7333 24.8506 22.7333 24.0498C22.7333 19.2402 18.7433 15.3438 13.8183 15.3438H9.24825Z",
    fill: "url(#paint0_linear_492_7557)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_492_7557",
    x1: 0.517471,
    y1: 25.5,
    x2: 28.011,
    y2: 15.4659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47E4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CCEDD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_492_7557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 25,
    fill: "white",
    transform: "translate(0.333252 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroupDuotoneSolid);
export default __webpack_public_path__ + "static/media/user-group-duotone-solid.d898ffacb1baa758122aca783b1ba3ce.svg";
export { ForwardRef as ReactComponent };